export default "__VITE_ASSET__1b2b92d3__"